// The canonical markdown lives in the repo-root docs/ folder so the weekly
// docs-sync workflow can publish it to the public docs site; the
// `@axilon-apps/docs/*` alias lives in tsconfig.base.json.
// eslint-disable-next-line @nx/enforce-module-boundaries
import content from '@axilon-apps/docs/terms-of-use.md?raw'
import MarkdownDocPage from '../../components/MarkdownDocPage/MarkdownDocPage'
import { legalDocHref } from './legal-doc-href'

const TermsOfUsePage = () => (
  <MarkdownDocPage
    title="Terms of Use"
    subtitle="The agreement governing use of the Axilon services."
    content={content}
    transformHref={legalDocHref}
  />
)

export default TermsOfUsePage
